import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import { ComplianceSettingForm } from './compliance-setting-form';
import { PrimaryTradeLicenseRequirementForm } from './primary-trade-license-requirement-form';
import { TradeCategoryForm } from './trade-category-form';
import { VendorTradeForm } from './vendor-trade-form';

export class PrimaryTradeForm extends FormGroup<{
  id: FormControl<number | undefined>;
  name: FormControl<string | undefined>;
  defaultTier: FormControl<number | undefined>;
  isTransporter: FormControl<boolean>;
  isProfessional: FormControl<boolean>;
  isNonProfessional: FormControl<boolean>;
  isProfessionalOrNonProfessional: FormControl<boolean>;
  isOnSite: FormControl<boolean>;

  TradeCategories?: FormArray<TradeCategoryForm>;
  VendorTrades?: FormArray<VendorTradeForm>;
  PrimaryTradeLicenseRequirements?: FormArray<PrimaryTradeLicenseRequirementForm>;
  ComplianceSettings?: FormArray<ComplianceSettingForm>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      name: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      defaultTier: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isTransporter: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isProfessional: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isNonProfessional: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isProfessionalOrNonProfessional: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isOnSite: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
  }
}

/*
TradeSpecificCompliances?: TradeSpecificCompliance[];
*/
